import script from "./PasswordResetForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./PasswordResetForm.vue?vue&type=script&lang=ts&setup=true"

import "./PasswordResetForm.vue?vue&type=style&index=0&id=f723b69a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f723b69a"]])

export default __exports__